import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { MaterialListService } from '../material-list.service';
import MaterialListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-list/material-list.entity';
import { LOCALIZED_PROPERTIES, MATERIAL_LIST_EXPORT_ID, MATERIAL_LIST_TITLE } from './material-list.constants';

@Injectable()
export class MaterialListExport {
  constructor(
    private exportService: ExportService,
    private materialListService: MaterialListService,
  ) {}

  private transformItem(item: MaterialListAttributes) {
    return {
      code: get(item, 'code', '??'),
      name: get(item, 'name', '??'),
      statusId: this.getStatus(get(item, 'statusId', '')),
    };
  }

  private getStatus(value: string | number): string {
    if(!value && value !== 0) {
        return '';
    }
    return value === 1 ? 'Activo' : 'Inactivo';
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: MATERIAL_LIST_EXPORT_ID,
      title: MATERIAL_LIST_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(MATERIAL_LIST_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.materialListService.findByFilter(buildQuery(
          seed(this.materialListService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(MATERIAL_LIST_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(MATERIAL_LIST_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
